import React from 'react'
import { useState, useEffect, useRef, useContext } from 'react'
import { useParams } from 'react-router-dom'
import { Button, Dialog, InputText, InputTextarea, Toast } from 'primereact'

import Card from '../../../../Base/Components/Card/Card'
import { useForm } from '../../../../Base/Hooks/useForm'
import Loader from '../../../../Base/Components/Loader/Loader'
import { toastShow } from '../../../../Base/Services/ToastService'
import { AuthContext } from '../../../../Base/Context/AuthContext/AuthContext'
import AutoCompleteDropdown from '../../../../Base/Components/Form/AutoCompleteDropdownOld'

import { getPublicAreas } from '../../../../API/Global/Areas/AreasRequests'
import { getPublicVehiculosPPF } from '../../../../API/Logistica/Vehiculos/VehiculosRequets'
import { getPublicMotoristasPPF } from '../../../../API/Logistica/Motoristas/MotoristasRequest'
import { IUPublicSolicitudMotoristas } from '../../../../API/Logistica/Motoristas/SolicitudMotoristasRequests'
import { Calendar } from 'primereact/calendar'

// import { getAreas } from '../../../../utils/Compras/Consultas_Requisicion'

import './CrearSolicitudMotorista.scss'
import { getDateTimeStringSQL } from '../../../../Base/Services/Moment/Luxon'

const CrearSolicitudMotorista = ({ showDialog, onHide, toast, edit, editTrunk, Usuario }) => {

    const toastModal = useRef(null);

    let { token } = useParams();
    if (!token) {
        token = localStorage.getItem('TokenPPF')
    }

    const { userAuth } = useContext(AuthContext)

    // const user = Usuario ? Usuario :  JSON.parse(localStorage.getItem('ppfUser'));
    const user = Usuario ? Usuario : userAuth;
    // const user =   JSON.parse(localStorage.getItem('ppfUser'));
    const [areas, setAreas] = useState([]);
    const [loading, setLoading] = useState(false);
    const [vehiculos, setVehiculos] = useState([]);
    const [motoristas, setMotoristas] = useState([]);

    const { values, handleInputChange, setValues, resetForm } = useForm({
        IdProgramacion: -1,
        IdSolicita: user?.idUser,
        IdEstado: 3619,
        Direccion: '',
        FechaSolicita: new Date(),
        Descripcion: '',
        Solicita: user?.UserName
    })

    const rest = () => {
        setValues({
            IdProgramacion: -1,
            IdSolicita: user?.idUser,
            IdEstado: 3619,
            Direccion: '',
            FechaSolicita: new Date(),
            Descripcion: '',
            Solicita: user?.UserName
        })
    }

    const getInfo = async () => {
        const a = await getPublicAreas(token);
        const v = await getPublicVehiculosPPF(token);
        const m = await getPublicMotoristasPPF(token);
        setMotoristas(m)
        setVehiculos(v);
        setAreas(a)
    }

    const verificarData = () => {
        return !values?.Departamento?.IdArea || values.FechaSolicita === null || values.Direccion.length === 0 || values.Descripcion.length === 0
    }

    const guardarInfo = async () => {
        setLoading(true);
        if (verificarData()) {
            toastShow(toastModal, 'warn', 'Debe de completar todos los campos.')
        } else {
            const data = {
                ...values,
                IdDepartamento: values.Departamento.IdArea,
                FechaSolicita: getDateTimeStringSQL(values.FechaSolicita),
                IdVehiculo: values.Vehiculo ? values.Vehiculo.Idvehiculo : null,
                IdMotorista: values.Motorista ? values.Motorista.IdMotorista : null,
                IdEstado: values.Motorista ? 3621 : 3619
            }
            const result = await IUPublicSolicitudMotoristas(data, token);
            onHide()
            resetForm()
            toastShow(toast, 'success', 'Solicitud guardada');
        }
        setLoading(false)
    }

    useEffect(() => {
        getInfo();
    }, [])

    useEffect(() => {
        rest()
    }, [Usuario])

    useEffect(() => {
        if (edit) {
            setValues({
                ...edit,
                FechaSolicita: new Date(edit.FechaSolicitaWeb),
                Departamento: areas.filter(e => e.IdArea === edit.IdDepartamento)[0],
                Motorista: motoristas.filter(e => e.IdMotorista === edit.IdMotorista)[0],
                Vehiculo: vehiculos.filter(e => e.Idvehiculo === edit.IdVehiculo)[0],

            })
        }
    }, [showDialog])


    return (
        <div>
            <Dialog visible={showDialog} onHide={e => { onHide(); rest(); }}
                header={<div><h3>Solicitud de Servicios de Motoristas</h3></div>}
            >
                <Toast ref={toastModal} />
                <Loader loading={loading} />
                {/* SOLICITUD DE MOTORISTA */}
                <div className='p-3'>
                    <div className='CrearSolicitudMotorista' style={{ minWidth: '80vw' }}>
                        <div>
                            <Card
                                titulo={'Solicita'}
                                contenido={<span> {values?.Solicita}</span>}
                            />

                        </div>

                        <AutoCompleteDropdown
                            value={values.Departamento}
                            items={areas}
                            field='Area'
                            name='Departamento'
                            label={'Departamento'}
                            onValueChange={e => handleInputChange(e, 'Departamento')}
                        />
                        <span className="p-float-label" style={{ width: '100%' }}>
                            <Calendar
                                value={values.FechaSolicita}
                                onChange={e => handleInputChange(e, 'FechaSolicita')}
                                showTime
                                hourFormat="12"
                                dateFormat="dd/mm/yy"
                                showIcon
                                className="p-mr-2"
                                style={{ width: '100%' }}
                            />
                            <label >Fecha actividad</label>
                        </span>


                        {/* <label>Fecha actividad</label>  */}
                        {/* </span> */}
                        <span className="p-float-label" style={{ width: '100%' }}>
                            <InputText
                                style={{ width: '100%' }}
                                value={values.Direccion}
                                onChange={handleInputChange}
                                name='Direccion'
                            />
                            <label >Dirección</label>
                        </span>
                    </div>
                    <div className='mt-5'>
                        <span className="p-float-label" style={{ width: '100%' }}>
                            <InputTextarea
                                style={{ width: '100%' }}
                                value={values.Descripcion}
                                onChange={handleInputChange}
                                name='Descripcion'
                                rows={5}
                            />
                            <label >Descripción de la actividad</label>
                        </span>
                    </div>
                </div>
                {/* ASIGNACION DE MOTORISTA */}
                <div>
                    <Card
                        titulo={<h4>Asignación</h4>}
                        contenido={<div className='p-3'>
                            <div className='d-flex' style={{ gap: 10 }}>
                                <AutoCompleteDropdown
                                    value={values.Motorista}
                                    items={motoristas}
                                    field='Nombre'
                                    name='Motorista'
                                    label={'Motorista'}
                                    onValueChange={e => handleInputChange(e, 'Motorista')}
                                    habilitar={!editTrunk}
                                />
                                <AutoCompleteDropdown
                                    value={values.Vehiculo}
                                    items={vehiculos}
                                    field='Vehiculo'
                                    name='Vehiculo'
                                    label={'Vehiculo'}
                                    onValueChange={e => handleInputChange(e, 'Vehiculo')}
                                    habilitar={!editTrunk}
                                />
                            </div>
                        </div>}
                    />
                </div>
                <div className='d-flex mt-4' style={{ justifyContent: 'flex-end', gap: 10 }}>
                    <Button className="p-button-secondary" label='Cancelar' icon='pi pi-times' onClick={onHide} />
                    <Button className="p-button-success" label='Guardar' icon='pi pi-save' onClick={guardarInfo} />
                </div>
            </Dialog >
        </div >
    )
}

export default CrearSolicitudMotorista